import Brace from "backbone.brace";

const Model = Brace.Model.extend();

export { Model as default };
